import React, { useState } from "react";
import Styles from "./home.module.css";
import Signupmodal from "./Signupmodal";

const SignupBox = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <div className={Styles.Signupbox_container}>
      <h2 className={Styles.textsign}>
        "Take charge of your future. Become a franchise owner today!"
      </h2>
      <div className={Styles.signbtncontainer}>
        <button
          type="button"
          className={Styles.SignupBoxbutton}
          onClick={toggleModal}
        >
          Get Our Franchise
        </button>
      </div>

      {/* Modal Component */}
      {isModalOpen && <Signupmodal closeModal={toggleModal} />}
    </div>
  );
};

export default SignupBox;
